<template>
  <div class="pl-16 pr-16 mr-10">
    <v-row class="pt-5">
      <v-col cols="12" offset="0">
        <v-row>
          <v-col cols="6"> <results-client :id="id" /> </v-col>
          <v-col cols="6"> <results-customer :id="id" /> </v-col>
          <v-col cols="6"> <results-context :id="id"/></v-col>
          <v-col cols="6"> <results-competition :id="id"/></v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import lodash from "lodash";

import { mapState } from "vuex";

import ResultsContext from "./ResultsContext";
import ResultsCompetition from "./ResultsCompetition";
import ResultsCustomer from "./ResultsCustomer";
import ResultsClient from "./ResultsClient";

export default {
  name: "ResultsFourCornersSummary",
  data() {
    return {};
  },
  components: {
    ResultsContext,
    ResultsClient,
    ResultsCustomer,
    ResultsCompetition,
  },
  props: {
    uid: String,
    id: String,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {},
};
</script>
